export default "__VITE_ASSET__B3RECAi2__"